module.exports = __webpack_public_path__ + "images/marker-recreatie.632611.png";